import { render } from "./FaqList.vue?vue&type=template&id=6e80d914"
import script from "./FaqList.vue?vue&type=script&lang=js"
export * from "./FaqList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__